import { GET_NOTIFICATIONS, DELETE_NOTIFICATIONS } from "./types";
import { getBaseURL } from "../../env/stage";
import { get, del } from "../../common/modules/http.client";
import { addMessage } from "./messageActions";

const NOTIFICATION_URL = getBaseURL() + "/notifications";

export const getNotifications = () => (dispatch: any) => {
  get(NOTIFICATION_URL)
    .then((res) =>
      dispatch({
        type: GET_NOTIFICATIONS,
        payload: res,
      })
    )
    .catch((err) => {
      console.log("err", err);
      dispatch(addMessage("Error getting notifications", err.statusText, "error"));
    });
};
export const deleteNotification = (notificationId: string) => (dispatch: any) => {
  del(NOTIFICATION_URL + "/" + notificationId)
    .then((res) =>
      dispatch({
        type: DELETE_NOTIFICATIONS,
        payload: {
          id: notificationId,
        },
      })
    )
    .catch((err) => {
      console.log("err", err);
      dispatch(addMessage("Error deleting notifications", err.statusText, "error"));
    });
};
